import { Anchoring } from './Anchoring';
export default class AnchoringLetGoData extends Anchoring {
    chainLength;
    chainShake;
    constructor(anchor, chainLength, chainShake, freeText) {
        super(anchor, freeText);
        this.chainShake = chainShake;
        this.chainLength = chainLength;
    }
}
//# sourceMappingURL=AnchoringVesselAtAnchorData.js.map